import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CultureService } from '@myia/ngx-localization';
import { AppConfig, AppMode, DashboardRoutePath } from '@shared';
import { ModeratorSessionsRoutePath } from './pages/shared/routes.paths';

@Component({
    template: ''
})
export class PortalAppRedirectComponent {
    constructor(activatedRoute: ActivatedRoute, cultureService: CultureService, router: Router) {
        activatedRoute.queryParams.subscribe(queryParams => {
            //https://stackoverflow.com/questions/36687164/pass-parameters-in-angular2-routeconfig-redirectto
            const cultureQS = queryParams['culture'];
            if (cultureQS) {
                cultureService.use(cultureQS).subscribe();
            }
            if (AppConfig.appMode === AppMode.myiaModerator) {
                // redirect to not found page
                router.navigate([`/${ModeratorSessionsRoutePath}`]);
            } else {
                // redirect to dashboard
                router.navigate([`/${DashboardRoutePath}`]);
            }
        });
    }

}
